<template>
  <div class="checkDetails" v-if="routeClass == 3">
    <div class="crumbs">
      <crumbs>
        <el-button
          type="primary"
          size="small"
          :disabled="
            !(
              info.is_have_bill == 1 &&
              (info.status == 3 ||
                info.status == 5 ||
                info.status == 6 ||
                info.status == 7)
            )
          "
          @click="getBillFile"
        >
          发票下载
        </el-button>
        <el-button
          type="primary"
          size="small"
          @click="getPolicyFile"
          :disabled="
            !(
              info.status == 3 ||
              info.status == 5 ||
              info.status == 6 ||
              info.status == 7
            )
          "
          >电子批单下载
        </el-button>
      </crumbs>
    </div>
    <div class="guarantee" v-if="info">
      <div class="guerLeft">
        <div class="guerImgBox">
          <img :src="status[info.status].url" alt="" />
          <div>
            <i class="iconfont" :class="status[info.status].icon"></i>
            {{ info.statusTxt }}
          </div>
        </div>
      </div>
      <div class="guerRight">
        <div class="guerRightTop">
          <p>批单号：{{ info.correct_num ? info.correct_num : "暂无" }}</p>
          <p class="premium">
            保费：<span>{{ info.policy_money }}</span>
          </p>
        </div>
        <div class="guerRightMiddle">
          <p>流水号：{{ info.num_id }}</p>
          <p>保险公司：{{ info.companyName }}</p>
          <p>批改时间：{{ info.c_time }}</p>
          <p>产品名称：{{ info.productName }}</p>
          <p>保障期限：{{ info.s_time }} - {{ info.e_time }}</p>
          <p>提交人：{{ info.adminName }}</p>
        </div>
      </div>
    </div>

    <div class="contentBox">
      <div class="itemBox">
        <div class="bTit">批单信息</div>
        <div class="conBox">
          <div class="conBoxFlex" v-if="info">
            <div class="left">
              <p>投保人名称：{{ info.applicationName }}</p>
              <p>被保人名称：{{ info.insuredName }}</p>
              <p>生效时间：{{ info.s_time }}</p>
              <p>批增人数：{{ info.add_num }}个</p>
              <p>批减人数: {{ info.change_num }}个</p>
              <p>
                应缴保费：<span class="textRed">{{ info.policy_money }}元</span>
              </p>
            </div>
            <div class="right" v-if="info.payVoucher">
              <span>缴费凭证扫描件：</span>
              <el-image
                :src="item"
                :preview-src-list="info.payVoucher.payVoucher"
                v-for="(item, index) in info.payVoucher.payVoucher"
                :key="index"
              >
              </el-image>
            </div>
          </div>
        </div>
      </div>
      <div class="itemBox">
        <div class="bTit">增加人员</div>
        <div class="conBox">
          <el-table :data="addPerson" style="width: 100%" size="mini">
            <el-table-column type="index" label="序号" width="80">
            </el-table-column>
            <el-table-column prop="name" label="姓名" min-width="90">
            </el-table-column>
            <el-table-column prop="code" label="身份证号" min-width="190">
            </el-table-column>
            <el-table-column
              prop="work_cate_title"
              label="工作类型"
              min-width="100"
            >
            </el-table-column>
            <el-table-column prop="money" label="保费金额" min-width="120">
            </el-table-column>
            <el-table-column
              prop="work_type_title"
              label="工种"
              show-overflow-tooltip
              min-width="200"
            >
            </el-table-column>
            <el-table-column prop="address" label="保障期限" min-width="360">
              <template slot-scope="scope">
                {{ scope.row.s_time }} -- {{ scope.row.e_time }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="itemBox">
        <div class="bTit">减少人员</div>
        <div class="conBox">
          <el-table :data="delPerson" style="width: 100%" size="mini">
            <el-table-column type="index" label="序号" width="80">
            </el-table-column>
            <el-table-column prop="name" label="姓名" min-width="90">
            </el-table-column>
            <el-table-column prop="code" label="身份证号" min-width="190">
            </el-table-column>
            <el-table-column
              prop="work_cate_title"
              label="工作类型"
              min-width="100"
            >
            </el-table-column>
            <el-table-column prop="money" label="保费金额" min-width="120">
            </el-table-column>
            <el-table-column
              prop="work_type_title"
              label="工种"
              show-overflow-tooltip
              min-width="200"
            >
            </el-table-column>
            <el-table-column label="保障期限" min-width="360">
              <template slot-scope="scope">
                {{ scope.row.s_time }} -- {{ scope.row.e_time }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="itemBox">
        <div class="bTit">其他文件</div>
        <div class="conBox">
          <p class="fileDown">
            <!-- v-if="info.insureFile" -->
            <span @click="down(info.correct_file)" v-if="info.correct_file">
              文件
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="logBox">
      <div class="logTit"><i class="el-icon-tickets"></i> 操作日志</div>
      <div class="logCon">
        <span class="btn" @click="logState = true" v-if="!logState">
          展开 <i class="el-icon-arrow-down"></i>
        </span>
        <span class="btn" @click="logState = false" v-else>
          收起 <i class="el-icon-arrow-up"></i>
        </span>
        <template v-for="(item, index) in Log">
          <p :key="index" :class="logState ? '' : 'show'">
            {{ item.createtime }}
            <span>{{ item.username }}</span>
            <span>{{ item.title }}</span>
          </p>
        </template>
      </div>
    </div>
  </div>
  <router-view v-else />
</template>
<script>
import {
  getCorrection,
  getCorrectionPerson,
  getOperationLog
} from "@/api/check";
import { getBillFile, getPolicyFile } from "@/api/public";
import download from "@/utils/download";
import crumbs from "@/components/common/crumbs";
export default {
  name: "guaDdetails",
  components: {
    crumbs
  },
  data() {
    return {
      routeClass: "",
      status: [],
      changeId: "",
      info: "", //订单详情
      delPerson: [], //减少人员
      addPerson: [], //添加人员
      logState: false,
      Log: []
    };
  },
  created() {
    // 获取当前路由等级
    this.routeClass = this.$route.matched.length;
    this.status = this.$store.state.orderStatus;
    this.changeId = this.$route.query.changeId;
    this.getCorrection(); //获取订单详情
    this.getCorrectionPerson(); //获取批单人员列表
    this.getOperationLog(); //操作记录接口
  },
  methods: {
    //获取批单详情
    getCorrection() {
      let that = this;
      getCorrection({ changeId: this.changeId })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.info = res.data;
            // 设置title
            document.title = "批改详情--" + res.data.applicationName;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }, //获取批单人员列表接口
    getCorrectionPerson() {
      let that = this;
      getCorrectionPerson({ changeId: this.changeId })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.addPerson = res.data.addPerson;
            that.delPerson = res.data.delPerson;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 操作记录
    getOperationLog() {
      let that = this;
      getOperationLog({ changeId: this.changeId })
        .then(function(res) {
          console.log(res);
          if (res.code == 1) {
            that.Log = res.data;
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    //申请开发票，下载发票
    getBillFile() {
      let that = this;
      let loadind = that.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      getBillFile({ changeId: this.changeId })
        .then(function(res) {
          loadind.close();
          console.log(res);
          if (res.code == 1) {
            if (res.data) {
              that.down(res.data.billUrl);
            } else {
              that.$message.success(res.msg);
            }
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }, //申请保单，下载保单
    getPolicyFile() {
      let that = this;
      let loadind = that.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      getPolicyFile({ changeId: this.changeId })
        .then(function(res) {
          loadind.close();
          console.log(res);
          if (res.code == 1) {
            if (res.data) {
              that.down(res.data.policyUrl);
            } else {
              that.$message.success(res.msg);
            }
          } else {
            that.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 下载
    down(downurl) {
      download(downurl);
    }
  }
};
</script>
<style lang="scss">
.checkDetails {
  padding: 0 !important;
  margin-top: 15px !important;
  background: #f4f5f7 !important;
  box-shadow: none !important;
  & > .crumbs {
    margin: 0 8px;
  }

  .guarantee {
    padding: 24px 40px 40px 24px;
    background: #ffffff
      linear-gradient(
        150deg,
        #ffffff 0%,
        rgba(245, 248, 251, 0.76) 100%,
        #64dfff 100%
      );
    box-shadow: 0px 2px 4px 0px rgba(4, 46, 111, 0.11);
    border-radius: 9px 10px 5px 5px;
    margin: 15px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    overflow: hidden;
    .guerLeft {
      width: 72px;
      height: 72px;
      margin-right: 30px;
      .guerImgBox {
        position: relative;
        top: -24px;
        height: 100%;
        img {
          position: absolute;
          top: -15px;
          left: -16px;
        }
        & > div {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          color: #fff;
          font-size: 14px;
          font-weight: 500;
          i {
            font-size: 25px;
            font-weight: 400;
            margin-top: 15px;
          }
        }
      }
    }
    .guerRight {
      width: calc(100% - 87px);
      .guerRightTop {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 20px;
        font-weight: 500;
        color: #000000;
        line-height: 28px;
        margin-bottom: 20px;
        p {
          margin: 0;
        }
        .premium {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
          line-height: 20px;
          span {
            font-size: 24px;
            color: #f76a37;
          }
        }
      }
      .guerRightMiddle {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
        & > p {
          width: 33.33%;
          font-size: 14px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          line-height: 22px;
          margin: 0;
        }
      }
      // .guerRightBottom {
      //   display: flex;
      //   justify-content: flex-start;
      //   align-items: center;
      //   margin-top: 30px;
      //   p {
      //     margin: 0;
      //     font-size: 14px;
      //     font-weight: 500;
      //     color: rgba(255, 255, 255, 0.85);
      //     border-radius: 15px 0px 15px 0px;
      //     background: #2d8aee;
      //     padding: 2px 12px;
      //     margin-right: 20px;
      //   }
      //   span {
      //     font-weight: 300;
      //     color: rgba(0, 0, 0, 0.85);
      //   }
      // }
    }
  }

  & > .contentBox {
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(4, 46, 111, 0.08);
    & > .itemBox + .itemBox {
      border-top: 1px solid #eee;
    }
    & > .itemBox {
      .bTit {
        font-size: 16px;
        font-weight: 500;
        color: #000000;
        line-height: 22px;
        padding: 15px 20px;
        position: relative;
      }
      .bTit:before {
        content: "";
        display: inline-block;
        width: 4px;
        height: 24px;
        background: #2d8aee;
        border-radius: 0px 10px 10px 0px;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }
      .conBox {
        padding: 5px 100px 20px 85px;
        .conBoxFlex {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          p {
            margin: 0;
            color: #333;
            font-size: 14px;
            font-weight: 400;
            color: #000000;
            line-height: 40px;
          }
          .left {
            min-width: 550px;
            margin-right: 20px;
          }
          .right {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            span {
              font-size: 14px;
              font-weight: 400;
              color: #000000;
              line-height: 20px;
            }
            .el-image {
              width: 200px;
              height: 200px;
            }
          }
        }
        .el-table {
          th {
            background: #f1f4f8;
          }
          .cell {
            padding-left: 20px;
            padding-right: 20px;
            line-height: 27px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(0, 0, 0, 0.85);
          }
        }
        .textRed {
          color: rgba(255, 0, 0, 0.85);
        }
        .fileDown {
          cursor: pointer;
        }
        .fileDown:hover {
          color: #409eff;
        }
      }
    }
  }
  & > .logBox {
    background: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(4, 46, 111, 0.08);
    opacity: 0.89;
    margin-top: 15px;
    overflow: hidden;
    .logTit {
      padding: 25px 35px 0;
      font-size: 16px;
      font-weight: 400;
      color: #000000;
      line-height: 22px;
      i {
        color: #2d8aee;
        margin-right: 8px;
        font-weight: 600;
      }
    }
    .logCon {
      margin: 30px 100px 40px 85px;
      background: #f0f3f7;
      padding: 15px 15px;
      position: relative;
      .btn {
        position: absolute;
        top: 15px;
        right: 15px;
        cursor: pointer;
        z-index: 2;
      }
      p {
        font-size: 14px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 20px;
        margin: 0;
        position: relative;
        span {
          font-size: 14px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          display: inline-block;
        }
        span:first-child {
          min-width: 100px;
          margin-left: 35px;
        }
      }
      p:before {
        content: "";
        display: inline-block;
        width: 14px;
        height: 14px;
        background: #f0f3f7;
        border: 2px solid #2d8aee;
        border-radius: 50%;
        margin-right: 20px;
        vertical-align: middle;
      }
      p + p {
        padding-top: 24px;
      }
      p + p::after {
        content: "";
        display: inline-block;
        width: 1px;
        height: 30px;
        position: absolute;
        background: #97979775;
        top: -2px;
        left: 7px;
      }
      p.show + .show {
        display: none;
      }
    }
  }
}
</style>
